// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__Hs1eW","control":"Checkout_control__h-op+","actions":"Checkout_actions__ENRJ7","submit":"Checkout_submit__55VRJ","invalid":"Checkout_invalid__6GaA2"};